<template>
	<el-popover v-if="(searchItem.length>0||filterlist.length>0)&&isshow" placement="bottom-end" trigger="click" :width="(filterlist.length > 0&&searchItem.length>0) ? 500 : 350">
		<table class="htmltable" v-if="searchItem.length>0">
			<tr v-for="(item,index) in searchItem" :key="index">
				<td><label>{{item.label}}</label></td>
				<td>
					<el-input v-if="item.coltype=='textarea'" type="textarea" rows="3" v-model="item.value" size="mini" :placeholder="item.placeholder"></el-input>
					<el-input v-if="item.coltype=='text'" type="text" v-model="item.value" size="mini" :placeholder="item.placeholder"></el-input>
					<el-date-picker v-if="item.coltype=='date'"
						v-model="item.value"
						type="date"
						:placeholder="item.placeholder"
						size="mini"
						value-format="yyyy-MM-dd"
					></el-date-picker>
					<el-date-picker v-if="item.coltype=='datetime_mm'"
						v-model="item.value"
						type="datetime"
						:placeholder="item.placeholder"
						size="mini"
						format="yyyy-MM-dd HH:mm"
						@change="val=>formatdate(val,'datetime_mm',item)"
					></el-date-picker>
					<el-select v-if="item.coltype=='select'" v-model="item.value" filterable size="mini"  :placeholder="item.placeholder" clearable>
					    <el-option
					      v-for="it in item.colsource"
					      :key="it.value"
					      :label="it.label"
					      :value="it.value" 
						  >
					    </el-option>
					</el-select>
				</td>
				<td :rowspan="searchItem.length" valign="top" class="filter" v-if="filterlist.length > 0&&index==0">
					<div>{{morefilter_lang.commfilter}}</div>
					<ul>
						<li v-for="(i, idx) in filterlist" :key="idx">
							<el-radio v-model="commfname" :label="i.fname" @change="Setfilterchecked(idx)">{{ i.fname }}</el-radio>
						</li>
					</ul>
				</td>
			</tr>
			<tr>
				<td colspan="4" class="bottombtn">
					<el-button @click="GetTabData" type="warning" size="mini">查询</el-button>
					<el-button @click="ClearSearch" size="mini">清空</el-button>
				</td>
			</tr>
		</table>
		<table class="htmltable" v-if="filterlist.length>0&&searchItem.length==0">
			<tr>
				<td class="filter">
					<div>{{morefilter_lang.commfilter}}</div>
					<ul>
						<li v-for="(i, idx) in filterlist" :key="idx">
							<el-radio v-model="commfname" :label="i.fname" @change="Setfilterchecked(idx)">{{ i.fname }}</el-radio>
						</li>
					</ul>
				</td>
			</tr>
			<tr>
				<td  class="bottombtn">
					<el-button @click="GetTabData" type="warning" size="mini">查询</el-button>
					<el-button @click="ClearSearch" size="mini">清空</el-button>
				</td>
			</tr>
		</table>
		<el-link slot="reference" type="primary">{{morefilter_lang.btnmorefilter}}</el-link>
	</el-popover>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	name:'morefilter',
	props: {
		l_id: {
			type: String,
			default:''
		},
		l_mode: {
			type: String,
			default:''
		},
		tab: {
			type: String,
			default:''
		},
	 },
	data() {
		return {
			morefilter_lang:{},
			filterlist:[],
			searchItem:[],
			commfname:'',
			isshow:false
		}
	},
	mounted() {
		//debugger
		//console.log('筛选 '+this.l_id,this.$tool.getcurrenttime());
		import('../../static/' + this.$theme + '/style/morefilter.scss');
		this.init();
	},
	methods:{
		init(){
			//debugger
			var that=this;
			this.$public.GetLanguageByMode('morefilter',this).then(res=>{
				//debugger
				if(res.state=='1'){
					that.morefilter_lang=that.$lang.label.morefilter;
					that.Getmorefilter();//获取更多搜索
					that.GetFilter();//获取常用搜索
				}
			});
		},
		formatdate(val,type,item){
			//debugger
			if(type=='datetime_mm'){
				item.value=this.$tool.datetotime(val);
			}
		},
		Getmorefilter(){
			var that=this;
			this.$apipost.get.GetFilterSet({l_id:this.l_id,type:'更多筛选'}).then(res => {
				//debugger
				if(res.state=='1'){
					res.list.forEach(e=>{
						if(that.morefilter_lang[e.label]!=undefined)
							e.label=that.morefilter_lang[e.label];
						if(e.placeholder!=undefined&&e.placeholder!='')
							e.placeholder=that.morefilter_lang[e.placeholder];
					});
					that.searchItem=res.list;
					if(res.list.length>0)
						that.isshow=true;
					this.$emit('sethandelshow',{type:'morefilter',show:res.list.length>0});
				}
			}).catch(e=>{
				
			});
		},
		GetFilter() {
			var that = this;
			this.$apipost.get.GetFilter({ l_mode: this.l_mode, type: this.tab }).then(res => {
				if (res != '') {
					res.data.forEach(e=>{
						if(that.morefilter_lang[e.fname]!=undefined)
							e.fname=that.morefilter_lang[e.fname];
					});
					that.filterlist = res.data;
				}
			});
		},
		//设置选中常用筛选项
		Setfilterchecked(value) {
			this.commfname = value;
		},
		GetTabData(){
			this.$emit('morefiltercb',{});
		},
		ClearSearch(){
			this.commfname='';
			this.searchItem.forEach(e=>{
				e.value='';
			});
		}		
	}
}
</script>
<style>
</style>
